import {inject, Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class FormErrorService {
  private toastr = inject(ToastrService);

  mapErrorToForm(form: FormGroup, response: HttpErrorResponse) {
    let responseError: {
      message?: string,
      errors?: Record<string, { errors: string[] }>
    } | undefined;

    if (typeof response.error === 'string') {
      try {
        responseError = JSON.parse(response.error);
      } catch {
        responseError = undefined;
      }
    } else {
      responseError = response.error;
    }

    this.toastr.error(responseError?.message, 'Error');

    const errors = responseError?.errors ?? {};
    Object.keys(errors)
      .forEach(fieldName => {
        const formField = form.get(fieldName);
        formField?.setErrors({serverError: errors[fieldName]});
      });
  }
}
